module.exports = __webpack_public_path__ + "img/platform-advantages.40c9a83f.jpg";